module.exports = __webpack_public_path__ + "img/checkbox-bg.eb05ca5.png";